// extracted by mini-css-extract-plugin
export default {"profileContainer":"ProfileMenu_profileContainer__1cQm9","profileMenuEntries":"ProfileMenu_profileMenuEntries__NPjQh"};